import { render, staticRenderFns } from "./part-email.vue?vue&type=template&id=1493dbd6&scoped=true&lang=pug"
import script from "./part-email.vue?vue&type=script&lang=js"
export * from "./part-email.vue?vue&type=script&lang=js"
import style0 from "./part-email.vue?vue&type=style&index=0&id=1493dbd6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1493dbd6",
  null
  
)

export default component.exports